import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { FORM_TEMPLATE_UPLOAD_URL, FORM_TEMPLATE_DELETE, FORM_TEMPLATE_UPDATE, FORM_TEMPLATE_ADD } from "./FormConfig";
import { getApiUrl } from "../../../../service/network/UrlMapper";
import MemoryType from "../../../../service/memory/enum/MemoryType";
import LocalStorageHandler from "../../../../service/memory/handler/LocalStorageHandler";

const localStorage = new LocalStorageHandler();
export default class FormService {
  async uploadFormTemplate(obj, formBucketName) {
    const token = localStorage.read(MemoryType.TOKEN);
    const event = {
      extension: "json",
      object: obj,
    };

    const res = axios.post(`${FORM_TEMPLATE_UPLOAD_URL}` + formBucketName?.value, event, {
      headers: { Authorization: `${token}` },
    });
    return (await res).data;
  }
  async addFormTemplateRequest(orgId, userId, title, description, type, status, category, countTowards5percent, metadata, contentId) {
    const token = localStorage.read(MemoryType.TOKEN);
    const event = {
        formTemplate: {
          title: title,
          description: description,
          contentId: contentId,
          namespace: type,
          status: status,
          category: category,
          countTowards5percent: countTowards5percent,
          metadata: metadata,
        },
        organizationId: orgId,
        userUID: userId,
        entityId: uuidv4(),
    };

    const res = axios.post(FORM_TEMPLATE_ADD, event, {
      headers: { Authorization: `${token}` },
    });
    return (await res).status;
  }

  async getAllFormMetaData(organizationId, statuses = [], withCategories = false) {
    const token = localStorage.read(MemoryType.TOKEN);
    const URL = `${getApiUrl()["service_base_url"]}/formstreamapp/organizationId/${organizationId}/api/v1/formTemplate`;
    const res = axios.get(URL, {
      headers: { Authorization: `${token}` },
      params: {
        statuses: statuses?.join(","),
        withCategories
      }
    });
    return (await res).data;
  }

  async getContentId(templateCode) {
    const token = localStorage.read(MemoryType.TOKEN);
    const URL = `${getApiUrl()["service_base_url"]}/formstreamapp/api/v1/formTemplate/${templateCode}
    `;
    const res = axios.get(URL, {
      headers: { Authorization: `${token}` },
    });
    return (await res).data;
  }

  async getJsonFromObjectStore(contentId, bucketName) {
    const token = localStorage.read(MemoryType.TOKEN);
    const URL = `${getApiUrl()["service_base_url"]}/event/api/v1/store/object/download?bucketName=${bucketName}&objectId=${contentId}&token=${token}`;

    const res = axios.get(URL, {
      headers: { Authorization: `${token}` },
    });
    return (await res).data;
  }

  async deleteFormTemplate(orgId, userId, title, description, contentId, templateId) {
    const token = localStorage.read(MemoryType.TOKEN);
    const event = {
        formTemplate: {
          title: title,
          description: description,
          templateCode: templateId,
          contentId: contentId,
        },
        organizationId: orgId,
        userUID: userId,
        entityId: uuidv4(),
    };

    const res = axios.post(FORM_TEMPLATE_DELETE, event, {
        headers: { Authorization: `${token}` },
      });
    return (await res).status;
  }

  async updateForm(orgId, userId, title, description, type, status, category, countTowards5percent, metadata, contentId, templateId) {
    const token = localStorage.read(MemoryType.TOKEN);
    const event = {
        formTemplate: {
          title: title,
          description: description,
          templateCode: templateId,
          contentId: contentId,
          namespace: type,
          status: status,
          category: category,
          countTowards5percent: countTowards5percent,
          metadata: metadata,
        },
        organizationId: orgId,
        userUID: userId,
        entityId: uuidv4(),

    };

    const res = axios.post(FORM_TEMPLATE_UPDATE, event, {
      headers: { Authorization: `${token}` },
    });
    return (await res).status;
  }

  async getMediaKeyObjectStore(contentId, bucketName) {
    const token = localStorage.read(MemoryType.TOKEN);
    const URL = `${getApiUrl()["service_base_url"]}/event/api/v1/store/object/download?bucketName=${bucketName}&objectId=${contentId}&token=${token}`;

    try {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "image/png",
        },
      });
      return res.data;
    } catch (err) {
      return null;
    }
  }
}

export const { uploadFormTemplate, addFormTemplateRequest, getContentId, getAllFormMetaData, getJsonFromObjectStore, getMediaKeyObjectStore } = new FormService();
